export default __webpack_public_path__ + "static/grape-candy-2c2b814672f5b7b04f6342e445ec70f5.png";